import script from "./VerticalLotteryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerticalLotteryCard.vue?vue&type=script&setup=true&lang=ts"

import "./VerticalLotteryCard.vue?vue&type=style&index=0&id=2cd379d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cd379d0"]])

export default __exports__